// Inside the Platform — public demo + captioned sample panels, on its own route.
import { C, SectionLabel, PublicPage } from "@/components/PublicShell";
import { ProductShowcase } from "@/components/ProductShowcase";

const ANCHORS = [
  { id: "regime-detection", label: "Regime Detection" },
  { id: "backtest-lab", label: "Backtest Lab" },
  { id: "premium-screener", label: "Premium Selling Screener" },
  { id: "dashboard-preview", label: "Dashboard" },
];

const jumpTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

const AnchorBar = () => (
  <div className="flex flex-wrap gap-1.5 mb-8 -mx-5 px-5 sm:mx-0 sm:px-0 overflow-x-auto"
    data-testid="platform-anchor-nav">
    {ANCHORS.map(a => (
      <button key={a.id} onClick={() => jumpTo(a.id)} data-testid={`anchor-${a.id}`}
        className="px-4 h-8 text-xs font-semibold rounded-md whitespace-nowrap transition-colors hover:bg-white/5"
        style={{ fontFamily: "'JetBrains Mono', monospace", background: "transparent", color: C.muted, border: `1px solid ${C.border}` }}>
        {a.label}
      </button>
    ))}
  </div>
);

export default function PlatformPage() {
  return (
    <PublicPage>
      <section className="py-16 px-5" data-testid="platform-page">
        <div className="max-w-5xl mx-auto">
          <SectionLabel text="Inside the platform" color={C.muted} />
          <h1 className="text-xl sm:text-2xl font-extrabold tracking-tight mb-3" style={{ color: C.text }}>
            Regime-aware, backtest-verified, portfolio-level.
          </h1>
          <p className="text-xs mb-6 max-w-xl" style={{ color: C.muted }}>
            The only wheel platform where HMM regime detection feeds strike selection, position
            monitoring, and drawdown control — validated against history, not just live-scanned.
          </p>
          <AnchorBar />
          <ProductShowcase C={C} />
        </div>
      </section>
    </PublicPage>
  );
}
